/**
 * empresaDoToken — qual empresa o login (token) do app abre.
 *
 * [Pablo 2026-10-23] Caso Coutinho × Lorca: a tela dizia "Coutinho" e a nota saía
 * na Lorca, porque o cadastro guardado no aparelho e o token apontavam para
 * empresas diferentes. Quem decide a empresa da nota é o TOKEN (o servidor só
 * olha ele), então a tela segue o token. Sem dependências: o harness roda isto
 * em Node.
 */
// [Pablo 2026-10-23] O conteúdo do token (sem conferir assinatura: quem confere é
// o servidor). Serve só pra o app saber QUAL empresa o token abre, que é a empresa
// em que a nota sai. Ilegível = null.
export function payloadDoToken(t) {
  try {
    const parte = String(t || '').split('.')[1];
    if (!parte) return null;
    const b64 = parte.replace(/-/g, '+').replace(/_/g, '/');
    const txt = atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4));
    let json = txt;
    try { json = new TextDecoder().decode(Uint8Array.from(txt, (c) => c.charCodeAt(0))); } catch (_) { /* fica o texto cru */ }
    const o = JSON.parse(json);
    return o && typeof o === 'object' ? o : null;
  } catch (_) { return null; }
}

// A empresa que vale é a do TOKEN. Se o cadastro guardado no aparelho diz outra,
// ele é corrigido pelo token (nunca o contrário): a tela passa a mostrar a empresa
// em que a nota de fato sairia. Devolve o cliente corrigido, ou o mesmo objeto.
export function clienteConformeToken(dados, t) {
  const p = payloadDoToken(t);
  if (!p || !p.cliente_id || !dados) return dados;
  if (Number(p.cliente_id) === Number(dados.id)) return dados;
  return {
    ...dados,
    id: p.cliente_id,
    cnpj: p.cnpj != null ? p.cnpj : dados.cnpj,
    razao_social: p.razao_social != null ? p.razao_social : dados.razao_social,
  };
}
